function GlobalAddress(aAddress) {
    "use strict";

    this.__type = 'GlobalAddress:www.veritracks.com';
    this.Id = -1;
    this.AddressTypeId = aAddress.AddressTypeId;
    this.Latitude = aAddress.Latitude;
    this.Longitude = aAddress.Longitude;
    this.Name = aAddress.Name;
    this.Radius = aAddress.Radius;
    this.Description = aAddress.Description;
}
if (typeof exports !== 'undefined') {
    module.exports = GlobalAddress;
}